import { render, staticRenderFns } from "./time-box.vue?vue&type=template&id=5c400888&scoped=true&"
import script from "./time-box.vue?vue&type=script&lang=js&"
export * from "./time-box.vue?vue&type=script&lang=js&"
import style0 from "./time-box.vue?vue&type=style&index=0&id=5c400888&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c400888",
  null
  
)

export default component.exports